import { Entity } from "@jobilla/entity";

export class PayeeAddress extends Entity {
  public city!: string;
  public country!: string;
  public postalCode!: string;
  public line1!: string;
  public line2!: string;
}
